import { render, staticRenderFns } from "./settings-workflows.vue?vue&type=template&id=c3f89516&"
import script from "./settings-workflows.vue?vue&type=script&lang=js&"
export * from "./settings-workflows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports